import useMutationWithValidation from '@hooks/useMutationWithValidation';
import useMyExpert from '@hooks/useMyExpert';
import { LinkEventCreateDocument, LinkEventCreateMutation, LinkEventCreateMutationVariables } from '@typing/Generated';
import { sanitizeHtmlHelper } from '@utils/htmlUtils';

type Resource = {
  __typename: string;
  id: string;
};

const useSanitizeHtml = (rawHtml: string | null | undefined, journeyId: string | null, resource: Resource | null) => {
  const myExpert = useMyExpert();
  const [linkEventCreate] = useMutationWithValidation<LinkEventCreateMutation, LinkEventCreateMutationVariables>(
    LinkEventCreateDocument,
    'linkEvent'
  );
  const handleLinkClick = (link: string) => {
    linkEventCreate({
      link,
      resourceId: resource?.id,
      resourceType: resource?.__typename
    });
  };

  return sanitizeHtmlHelper(rawHtml, journeyId, handleLinkClick, myExpert);
};

export default useSanitizeHtml;
